/**
 * TP02 G9 / G6 — Czech long-label chrome fixture (not product i18n).
 * Consumed by unit tests, e2e hermetic hub path, and the i18n fixture bridge.
 */

export const TP02_CZECH_LONG_LABEL_MATRIX = [
  {
    id: 'kpi-unpaid-orders',
    /** Maps → tenantCommandCenter.kpis.pending */
    i18nKey: 'tenantCommandCenter.kpis.pending',
    label: 'Nezaplacené objednávky čekající na potvrzení platby bankovním převodem',
    value: '12',
  },
  {
    id: 'kpi-stock-lock',
    /** Maps → tenantCommandCenter.kpis.kiosks + API kiosksOnlineLabel (secondary wrap). */
    i18nKey: 'tenantCommandCenter.kpis.kiosks',
    label: 'Zámek materializace skladu — dlouhý provozní název metriky',
    value: 'Žádný aktivní zámek materializace skladu',
  },
  {
    id: 'kpi-incident-queue',
    /** Maps → tenantCommandCenter.kpis.refunds */
    i18nKey: 'tenantCommandCenter.kpis.refunds',
    label: 'Naléhavé — problém s platbou po „Zaplatit“ ve frontě událostí',
    value: '3',
  },
  {
    id: 'kpi-conversion',
    /** Maps → tenantCommandCenter.kpis.conversion (+ analytics.kpis.conversion) */
    i18nKey: 'tenantCommandCenter.kpis.conversion',
    label: 'Míra konverze platebního potvrzení za zvolené období',
    value: '24,7 %',
  },
] as const;

export type Tp02CzechLongLabelRow = (typeof TP02_CZECH_LONG_LABEL_MATRIX)[number];

/** Window key set by Playwright `addInitScript` before i18n bootstrap. */
export const TP02_CZECH_LONG_LABEL_WINDOW_KEY = '__TP02_CZECH_LONG_LABEL_FIXTURE__' as const;

/**
 * Deep-merge overlay for `cs` admin namespace — fixture only; never written into
 * `locales/cs/admin.json`.
 */
export function buildTp02CzechLongLabelI18nOverlay(
  rows: readonly Tp02CzechLongLabelRow[] = TP02_CZECH_LONG_LABEL_MATRIX,
): Record<string, unknown> {
  const byId = Object.fromEntries(rows.map((row) => [row.id, row])) as Record<
    string,
    Tp02CzechLongLabelRow
  >;
  const pending = byId['kpi-unpaid-orders'];
  const kiosks = byId['kpi-stock-lock'];
  const refunds = byId['kpi-incident-queue'];
  const conversion = byId['kpi-conversion'];

  return {
    tenantCommandCenter: {
      kpis: {
        ...(pending ? { pending: pending.label } : {}),
        ...(kiosks ? { kiosks: kiosks.label } : {}),
        ...(refunds ? { refunds: refunds.label } : {}),
        ...(conversion ? { conversion: conversion.label } : {}),
      },
    },
    analytics: {
      kpis: {
        ...(pending ? { transactions: pending.label } : {}),
        ...(kiosks ? { avgOrder: kiosks.label } : {}),
        ...(refunds ? { refunds: refunds.label } : {}),
        ...(conversion
          ? { conversion: conversion.label, grossRevenue: conversion.label }
          : {}),
      },
    },
  };
}
